class DrawerSizeGuide extends HTMLElement {
  data: any;
  $name: HTMLElement;
  $table: HTMLElement;
  $image: HTMLElement;
  $notes: HTMLElement;

  constructor() {
    super();
    this.data = window.metaobjectSizeGuides?.find((d: any) => d.id === this.dataset.sizeGuideId);
    this.$name = this.querySelector(".size-guide-name")!;
    this.$table = this.querySelector(".size-guide-table")!;
    this.$image = this.querySelector(".size-guide-how-to-measure-image")!;
    this.$notes = this.querySelector(".size-guide-notes")!;
  }

  connectedCallback() {
    if (!this.data) return;
    this.setupName();
    this.setupTable();
    this.setupImage();
    this.setupNotes();
  }

  setupName() {
    if (!this.data) return;
    const { name } = this.data;
    this.$name.textContent = name;
  }

  setupTable() {
    if (!this.data) return;
    const { table_rows } = this.data;
    const $tbody = this.$table.querySelector<HTMLTableSectionElement>("tbody")!;

    table_rows.forEach((row: any) => {
      const $tr = document.createElement("tr");
      row.forEach((cell: any) => {
        const $td = document.createElement("td");
        $td.textContent = cell?.trim();
        $tr.appendChild($td);
      });
      $tbody.appendChild($tr);
    });
  }

  setupImage() {
    if (!this.data) return;
    const { how_to_measure_image } = this.data;
    const $img = document.createElement("img");
    $img.src = how_to_measure_image;
    $img.style.maxWidth = "100%";
    this.$image.appendChild($img);
  }

  setupNotes() {
    if (!this.data) return;
    const { notes } = this.data;
    this.$notes.textContent = notes;
  }
}

customElements.define("drawer-size-guide", DrawerSizeGuide);
